import { FC } from 'react';
import { FinanceFilterCardProps, FinanceFilterType } from './types';
import { FinanceDealDateRange } from './cards/FinanceDealDateRange';
import { FinanceSalesRep } from './cards/FinanceSalesRep';
import { FinanceLocation } from './cards/FinanceLocation';
import { FinancePaymentType } from './cards/FinancePaymentType';
import { FinanceDealStatus } from './cards/FinanceDealStatus';

export const financeComponentCardToTypeMapper: Record<
  Exclude<FinanceFilterType, FinanceFilterType.DATE_TYPE>,
  { label: string; component: FC<FinanceFilterCardProps> }
> = {
  [FinanceFilterType.DEAL_DATE]: { label: 'Date', component: FinanceDealDateRange as any },
  [FinanceFilterType.SALES_REP]: { label: 'Sales Rep', component: FinanceSalesRep as any },
  [FinanceFilterType.LOCATION]: { label: 'Location', component: FinanceLocation as any },
  [FinanceFilterType.PAYMENT_TYPE]: { label: 'Payment Type', component: FinancePaymentType as any },
  [FinanceFilterType.DEAL_STATUS]: { label: 'Deal Status', component: FinanceDealStatus as any },
};
